import { render, staticRenderFns } from "./EmbededModules.vue?vue&type=template&id=23404600&scoped=true&"
import script from "./EmbededModules.vue?vue&type=script&lang=ts&"
export * from "./EmbededModules.vue?vue&type=script&lang=ts&"
import style0 from "./EmbededModules.vue?vue&type=style&index=0&id=23404600&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23404600",
  null
  
)

export default component.exports